import {Injectable} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {AuthService} from '../_services/auth.service';
import {UserService} from '../_services/user.service';
import {JOB_REQUEST_STATUS, USER_EVENT_TYPE} from '../constants';
import {EventTrackingService} from "../_services/event-tracking.service";
import {mergeMap} from "rxjs/operators";
import {UtilitiesService} from "../_services/utilities.service";

@Injectable({
    providedIn: 'root'
})

export class AppointmentsOrQuotesGuard implements CanActivate {

    userData: any = {};
    routerSubscription: Subscription;

    constructor(private router: Router,
                private authService: AuthService,
                private userService: UserService,
                private eventTrackingService: EventTrackingService) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (!this.authService.loggedIn()) {
            return new Observable<boolean>(() => {
                location.reload();
            });
        } else {
            return this.checkJRsAndNavigate();
        }
    } // canActivate()

    checkJRsAndNavigate() {
        return this.userService.findJobRequests().pipe(
            mergeMap((result: any) => {
                if (result.responseCode == 100 && UtilitiesService.isNotEmpty(result.jobRequests)) {
                    const jobRequest = result.jobRequests[0];
                    const createDate = UtilitiesService.dateFromString(jobRequest.createDate);
                    const now = new Date();
                    this.eventTrackingService.trackSuccessEvent(this.constructor.name, 'success', USER_EVENT_TYPE.FIND_JOB_REQUESTS, '/user/lookupvehicle', null, result.responseCode);

                    // if latest jobRequest create date is today route to quotes or appointments, else to QF
                    if (now.getFullYear() === createDate.getFullYear() && now.getMonth() === createDate.getMonth() && now.getDay() && createDate.getDay()) {
                        if (jobRequest.status === JOB_REQUEST_STATUS.PRICING || jobRequest.status === JOB_REQUEST_STATUS.PENDING_PARTNER
                            || (UtilitiesService.isEmpty(jobRequest.times) && jobRequest.status === JOB_REQUEST_STATUS.PENDING)) {
                            return this.router.navigate(['/quotes']);
                        } else if (jobRequest.status === JOB_REQUEST_STATUS.READY || jobRequest.status === JOB_REQUEST_STATUS.PENDING) {
                            return this.router.navigate(['/appointments']);
                        } else {
                            return this.navigateToQFOrRefresh();
                        }
                    } else {
                        return this.navigateToQFOrRefresh();
                    }
                } else {
                    this.eventTrackingService.trackErrorEvent(this.constructor.name, 'error', USER_EVENT_TYPE.FIND_JOB_REQUESTS, '/user/lookupvehicle', null, result.responseCode);
                    return this.navigateToQFOrRefresh();
                }
            })
        ).catch((error: any) => {
            this.eventTrackingService.trackErrorEvent(this.constructor.name, 'error', USER_EVENT_TYPE.FIND_JOB_REQUESTS, '/user/lookupvehicle', null, error.responseCode);
            return this.router.navigate(['/book']);
        });
    } // checkJRsAndNavigate()

    // we need this cuz router.navigate does not refresh page if we try to navigate to path we are currently on
    navigateToQFOrRefresh() {
        let currentPath = this.router.routerState.snapshot.url.split('#').shift();
        if (currentPath === '/newservice' || currentPath === '/newuser' || currentPath === '/book/newuser') {
            return new Observable<boolean>(() => {
                location.reload();
            });
        } else {
            return this.router.navigate(['/book']);
        }
    } // navigateToQFOrRefresh()
}
